module.exports = __webpack_public_path__ + "img/SA.f1ce184e.png";